import { Navigate, Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LoadingState } from "@/components/common/States";

const Denied = ({ message }) => {
  const { logout } = useAuth();
  return (
    <div className="min-h-screen grid place-items-center p-6" data-testid="access-denied-page">
      <div className="max-w-md text-center">
        <ShieldAlert className="mx-auto h-10 w-10 text-[#E11D2E]" aria-hidden />
        <h1 className="font-brand text-2xl font-extrabold mt-4">Akses ditolak</h1>
        <p className="text-muted-foreground mt-2">{message}</p>
        <div className="mt-6 flex justify-center gap-2">
          <Button asChild variant="outline" data-testid="denied-home-link"><Link to="/">Ke halaman utama</Link></Button>
          <Button onClick={logout} data-testid="denied-logout-button">Keluar</Button>
        </div>
      </div>
    </div>
  );
};

export const RequireAuth = ({ space, children }) => {
  const { me, loading } = useAuth();
  if (loading) return <div className="p-10"><LoadingState /></div>;
  if (!me) return <Navigate to="/masuk" replace />;
  if (space === "platform" && me.platform_role !== "platform_admin") {
    return <Denied message="Pusat Kendali SIST hanya dapat diakses oleh Admin Platform." />;
  }
  if (space === "school" && !me.active_school) {
    return <Denied message="Akun Anda tidak memiliki keanggotaan sekolah. Admin Platform tidak otomatis menjadi pengelola sekolah." />;
  }
  return children;
};

export const HomeRedirect = () => {
  const { me, loading } = useAuth();
  if (loading) return <div className="p-10"><LoadingState /></div>;
  if (!me) return <Navigate to="/masuk" replace />;
  if (me.platform_role === "platform_admin") return <Navigate to="/pusat-kendali" replace />;
  if (me.active_school) return <Navigate to="/sekolah" replace />;
  return <Denied message="Akun Anda belum terhubung ke sekolah mana pun." />;
};
